import { jsx as m } from "react/jsx-runtime";
import { FormikContext as s } from "formik";
import { forwardRef as b, useState as I, useContext as k, useRef as E, useImperativeHandle as F, useEffect as y, useCallback as r } from "react";
import { useMultiStyleConfig as R } from "@chakra-ui/react";
import { InputComponent as S } from "./Input.component.es.js";
import { InputStylesProvider as V } from "./Input.context.es.js";
import { i as w } from "../../isEqual-24663bfb.js";
const z = b(
  ({ size: c, variant: i, maxLength: l, ...e }, C) => {
    const [o, a] = I(e.value ?? e.defaultValue), u = e.disableFormik ? void 0 : k(s), t = E(null), f = e.value && e.onChange, v = R("InputTheme", {
      size: c,
      variant: i
    });
    F(C, () => t.current), y(() => {
      w(o, e.value) || a(e.value);
    }, [e.value]);
    const d = r(
      (n) => {
        l && n.target.value.length > l || (e.onChange ? e.onChange(n) : a(n.target.value));
      },
      [e.onChange]
    ), h = r(() => {
      var n;
      if (u && e.name)
        u.setFieldValue(e.name, ""), u.setFieldTouched(e.name, !1);
      else if (e.onChange) {
        t.current.value = "";
        const g = new Event("input", {
          bubbles: !0,
          cancelable: !0
        });
        t.current.dispatchEvent(g);
      } else
        a("");
      (n = e.onClear) == null || n.call(e);
    }, [e.onChange]);
    return /* @__PURE__ */ m(V, { value: v, children: /* @__PURE__ */ m(
      S,
      {
        onChange: f ? e.onChange : d,
        onClear: h,
        ref: t,
        value: f ? e.value : o,
        variant: i,
        maxLength: l,
        ...e
      }
    ) });
  }
);
export {
  z as Input
};
//# sourceMappingURL=Input.container.es.js.map
